import { render, staticRenderFns } from "./structureSectting.vue?vue&type=template&id=800d82c6&scoped=true"
import script from "./structureSectting.vue?vue&type=script&lang=js"
export * from "./structureSectting.vue?vue&type=script&lang=js"
import style0 from "./structureSectting.vue?vue&type=style&index=0&id=800d82c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800d82c6",
  null
  
)

export default component.exports